import { render, staticRenderFns } from "./TournamentConditions.vue?vue&type=template&id=07b82c0d&scoped=true"
import script from "./TournamentConditions.vue?vue&type=script&lang=js"
export * from "./TournamentConditions.vue?vue&type=script&lang=js"
import style0 from "./TournamentConditions.vue?vue&type=style&index=0&id=07b82c0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b82c0d",
  null
  
)

export default component.exports